import React, { Component } from 'react'
import { Editor } from 'react-draft-wysiwyg'
import { convertToRaw, convertFromRaw, EditorState } from 'draft-js';
import { mdToDraftjs, draftjsToMd } from 'draftjs-md-converter';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { InputLabel, FormControl, FormHelperText } from '@material-ui/core';
import removeMd from 'remove-markdown';
import Styles from 'styles'

export class RichTextEditor extends Component {
  constructor(props) {
    super(props)
    const { value } = props
    this.state = {
      ...this.state,
      editorMd: value || '',
      editorState: this.editorStateFromMarkdown(value),
    }
  }

  componentDidUpdate() {
    const { value } = this.props
    if (value !== this.state.editorMd) {
      this.setState({
        editorMd: value || '',
        editorState: this.editorStateFromMarkdown(value),
      })
    }
  }

  editorStateFromMarkdown = (value) => {
    return value ? EditorState.createWithContent(convertFromRaw(mdToDraftjs(value))) : EditorState.createEmpty()
  }

  markdownFromEditorState = (editorState) => {
    return draftjsToMd(convertToRaw(editorState.getCurrentContent()))
  }

  handleEditorStateChange = (editorState) => {
    const markDown = this.markdownFromEditorState(editorState)
    this.props.onChange({ target: { value: markDown } })
    this.setState({
      editorState: editorState,
      editorMd: markDown,
    })
  }

  get label() {
    return this.props.label + (this.props.required ? ' *' : '')
  }

  handleBlur = (e) => {
    if (this.state.editorMd !== '' && !removeMd(this.state.editorMd).trim()) {
      this.props.onChange({ target: { value: '' } })
      this.setState({
        editorState: EditorState.createEmpty(),
        editorMd: '',
      })
    }
  }

  render = () => {
    return <div className={styles({ root: true, error: !!this.props.error, disabled: !!this.props.disabled })}>
      <FormControl fullWidth>
        <InputLabel error={this.props.error} shrink={true}>{this.label}</InputLabel>
        <Editor {...this.editorProps}
          disabled={this.props.disabled}
          toolbarHidden={this.props.disabled}
          onEditorStateChange={this.handleEditorStateChange}
          editorState={this.state.editorState}
          toolbarOnFocus={true}
          onBlur={this.handleBlur}
          toolbar={{
            options: ['inline', 'blockType', 'list'],
            inline: {
              options: ['bold', 'italic'],
            },
            list: {
              options: ['unordered', 'ordered'],
            }
          }}
        />
        {this.props.error &&
          <FormHelperText error={true}>{this.props.helperText}</FormHelperText>
        }
      </FormControl>
    </div>
  }
}
export default RichTextEditor

const styles = Styles({
  root: {
    marginBottom: '12px',
    '& .rdw-dropdown-wrapper > a.rdw-dropdown-selectedtext': {
      float: 'none',
      color: 'black',
      fontWeight: 'normal',
      padding: '2px',
    },
    '& .rdw-editor-main': {
      borderBottom: 'solid 1px #a0a0a0',
      paddingLeft: '0.5em',
      paddingRight: '0.5em',
      background: '#e6eaf1',
      transition: 'border 300ms, margin 300ms',
      lineHeight: 1.3,
      '&:hover, &:focus-within': {
        borderBottom: 'solid 2px #000',
        marginBottom: -1
      }
    },
    '& .rdw-editor-main h1,h2,h3,h4,h5,h6': {
      'margin': 'initial',
      'padding': 'initial',
    },
    '& .rdw-editor-toolbar[aria-hidden="true"]': {
      display: 'none !important',
    },
    '& .rdw-editor-toolbar': {
      marginBottom: 0,
      borderRadius: 0,
      borderColor: '#a0a0a0',
      borderLeft: 'none',
      borderRight: 'none',
      background: '#f5f7fa'
    },
    '& .rdw-editor-wrapper': {
      marginTop: '1.4em',
    },
    '& .rdw-option-wrapper, .rdw-dropdown-wrapper': {
      borderColor: '#ddd',
      '&:hover': {
        boxShadow: 'none',
        background: '#f5f5f5',
      },
      '&:active, &.rdw-option-active': {
        boxShadow: 'none',
        background: '#e4e4e4',
      }
    }
  },
  disabled: {
    '& .rdw-editor-main': {
      border: 'none !important',
      marginBottom: '0 !important'
    }
  },
  error: {
    '& .rdw-editor-main': {
      borderBottom: 'solid 2px #6AAEAA !important',
      marginBottom: '-1 !important'
    }
  }
})